import { TableDomain } from "_components/Abstractions/TableDomain";
import { stringToDate } from "../../../domain/Configuration";

export function ExternalWeighingTicketTable({ items, selectedItems, onSelectedItemsChanged }) {
  const keyColumn = "externalTicketId";
  const columns = [
    {
      name: "ticketNumber",
      headerName: "Numer kwitu",
    },
    {
      name: "contractorName",
      headerName: "Kontrahent",
    },
    {
      name: "weightNet",
      headerName: "Masa netto [kg]",
    },
    {
      name: "dateWeighFirst",
      headerName: "Data ważenia 1",
      map: (x) => stringToDate(x.dateWeighFirst),
    },
    {
      name: "dateWeighSecond",
      headerName: "Data ważenia 2",
      map: (x) => stringToDate(x.dateWeighSecond),
    }
  ];

  const props = {
    keyColumn,
    columns,
    items,
    multiSelect: true,
    onSelectedItemsChanged,
    selectedItems,
  };

  return <TableDomain {...props} />;
}
